const NON_VALID_CHARACTERS_FROM_0_TO_9_IN_ASCII = /([\u0000-\u0009])/g
const NON_VALID_CHARACTERS_FROM_11_TO_12_IN_ASCII = /([\u000B-\u000C])/g
const NON_VALID_CHARACTERS_FROM_14_TO_31_IN_ASCII = /([\u000E-\u001F])/g
const NON_VALID_CHARACTER_173_IN_ASCII = /([\u00AD])/g
const SAFE_REPLACEMENT_CHARACTER = ''

export function removalOfNotSupportedCharacters(text: string) {
  if (!text) {
    return ''
  }

  text = text.replace(NON_VALID_CHARACTERS_FROM_0_TO_9_IN_ASCII, SAFE_REPLACEMENT_CHARACTER)
  text = text.replace(NON_VALID_CHARACTERS_FROM_11_TO_12_IN_ASCII, SAFE_REPLACEMENT_CHARACTER)
  text = text.replace(NON_VALID_CHARACTERS_FROM_14_TO_31_IN_ASCII, SAFE_REPLACEMENT_CHARACTER)
  text = text.replace(NON_VALID_CHARACTER_173_IN_ASCII, SAFE_REPLACEMENT_CHARACTER)

  return text
}



// WEBPACK FOOTER //
// ./src/app/aspire/common/util/unsupported-chars-util.ts